module.exports = __webpack_public_path__ + "static/img/Gallery04.ad5451f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery04.jpg
// module id = bCMU
// module chunks = 12